import React, { useEffect, useState } from 'react'
import * as API from "../../framework/API/api"
import { ENTITYNAME, LOGEVENT, MODULE, SLOT_TYPE, TOAST_TYPES } from "../../framework/constant/constant";
import { useTranslation } from '../../locale/useTranslation';
import { utility } from '../../framework/utility/utilityProvider';
import { EditPageHeader } from '../../components/EditPageHeader';
import BossDialog from '../../components/BossDialog';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import ToastNotification from '../../components/ToastNotification';
import { TimePickerWithFormat } from '../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat';
import AddRoundButton from '../../framework/forms/helpercomponents/buttons/AddRoundButton';
import { Grid, GridColumn } from '@progress/kendo-react-grid';
import ProgramScheduleSlotEditForm from '../Planning/ProgramScheduleSlotEditForm';
import moment from 'moment';
import { DateTimeCell } from '../../framework/forms/helpercomponents/CustomGridCells/DateCell';

const SlotEditForm = (props) => {
    const lang = useTranslation();

    const blankDataItem = {
        ...props?.item,
        Title: props?.item?.copy ? "Copy of " + props?.item?.Title : props?.item?.Title ?? "",
        CustomTitle: props?.item?.CustomTitle ?? "",
        Description: props?.item?.Description ?? "",
        CustomDescription: props?.item?.CustomDescription ?? "",
        Code: props?.item?.Code ?? "",
        Duration: props?.item?.Duration ? utility.convertMilisecondsToStringWithFrames(props?.item?.Duration) : "00:00:00:00",
        Genre: props?.item?.Genre ?? {},
        ProductionYear: props?.item?.ProductionYear ?? "",
        PGRating: props?.item?.PGRating ?? {},
        TargetAudience: props?.item?.TargetAudience ?? {},
        ProductionType: props?.item?.ProductionType ?? {},
        SlotType: props?.item?.SlotType ?? {},
        BgColor: props?.item?.BgColor ?? "",
        FgColor: props?.item?.FgColor ?? "#ffffff",
        Breaks: props?.item?.Breaks ?? 0,
        Archive: props?.item?.Archive ?? false,
    }

    const [dataItem, setDataItem] = useState(blankDataItem);
    const [genres, setGenres] = useState([]);
    const [pGRatings, setPGRatings] = useState([]);
    const [targetAudiences, setTargetAudiences] = useState([]);
    const [productionTypes, setProductionTypes] = useState([]);
    const [slotTypes, setSlotTypes] = useState([]);
    const [gridData, setGridData] = useState([]);
    const [showProgramScheduleSlotForm, setShowProgramScheduleSlotForm] = useState(false);
    const [selectedProgramScheduleSlotItem, setSelectedProgramScheduleSlotItem] = useState(null);

    useEffect(() => {
        loadCombo();
        if (props?.item?._id) {
            loadProgramScheduleSlots();
        }
    }, [])

    const loadCombo = async () => {
        const genreRes = await API.getDataLookup(ENTITYNAME.Genre, { sort: { Description: 1 } });
        setGenres(genreRes.data);
        const pGRatingRes = await API.getDataLookup(ENTITYNAME.PGRating, { sort: { Description: 1 } });
        setPGRatings(pGRatingRes.data);
        const targetAudienceRes = await API.getDataLookup(ENTITYNAME.Audience, { sort: { Description: 1 } });
        setTargetAudiences(targetAudienceRes.data);
        const productionTypeRes = await API.getDataLookup(ENTITYNAME.ProductionType, { sort: { Description: 1 } });
        setProductionTypes(productionTypeRes.data);
        const slotTypeRes = Object.keys(SLOT_TYPE).map((x) => {
            return {
                _id: SLOT_TYPE[x],
                Description: x
            }
        });
        setSlotTypes(slotTypeRes);
    }

    const loadProgramScheduleSlots = async () => {
        try {
            const res = await API.getData(ENTITYNAME.ProgramScheduleSlot, {query: [['Slot._id', '=', props?.item?._id]], sort: { SID: 1 }});
            if (res.success) {setGridData(res.data ?? []);}
        } catch (err) {
            console.error("Failed to load ProgramScheduleSlots", err);
        }
    };
    const onChange = (e) => {
        if (e.target.name === 'Archive') {
            setDataItem({ ...dataItem, Archive: !dataItem.Archive });
        }
        else {
            setDataItem({ ...dataItem, [e.target.name]: e.target.value });
        }
    }
    const isValid = () => {
        if (dataItem.Title == undefined || dataItem.Title == "") {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_enter_title_error_message });
            return false;
        }
        return true;
    }

    const handleSubmit = async () => {
        if (!isValid()) return;
        const saveData = {
            _id: dataItem?._id,
            SID: dataItem?.SID,
            Title: dataItem?.Title,
            CustomTitle: dataItem?.CustomTitle,
            Description: dataItem?.Description,
            CustomDescription: dataItem?.CustomDescription,
            Code: dataItem?.Code,
            Duration: dataItem?.Duration ? utility.convertStringWithFramesToMilliseconds(dataItem?.Duration) : null,
            Genre: dataItem?.Genre && Object.keys(dataItem?.Genre).length > 0 ? {
                _id: dataItem?.Genre?._id,
                SID: dataItem?.Genre?.SID,
                Description: dataItem?.Genre?.Description
            } : {},
            ProductionYear: dataItem?.ProductionYear,
            PGRating: dataItem?.PGRating && Object.keys(dataItem?.PGRating).length > 0 ? {
                _id: dataItem?.PGRating?._id,
                Description: dataItem?.PGRating?.Description
            } : {},
            TargetAudience: dataItem?.TargetAudience && Object.keys(dataItem?.TargetAudience).length > 0 ? {
                _id: dataItem?.TargetAudience?._id,
                Description: dataItem?.TargetAudience?.Description
            } : {},
            ProductionType: dataItem?.ProductionType && Object.keys(dataItem?.ProductionType).length > 0 ? {
                _id: dataItem?.ProductionType?._id,
                Description: dataItem?.ProductionType?.Description
            } : {},
            SlotType: dataItem?.SlotType && Object.keys(dataItem?.SlotType).length > 0 ? {
                _id: dataItem?.SlotType?._id,
                Description: dataItem?.SlotType?.Description
            } : {},
            BgColor: dataItem?.BgColor,
            FgColor: dataItem?.FgColor,
            Breaks: dataItem?.Breaks ?? 0,
            Archive: dataItem.Archive ?? false,
            checkDuplicate: true,
            query: [["Title", "=", dataItem.Title]]
        }
        console.log(saveData);
        const res = await API.saveData(ENTITYNAME.Slot, saveData);
        if (res.success) {
            let logData = { event: res.message == "updated" ? LOGEVENT.UPDATE : LOGEVENT.INSERT, module: MODULE.SLOT, data: res.data, message: res.message };
            API.SaveLogs(logData);
            props.cancelEdit();
            props.refresh();
            utility.deleteLocalStorageItem(ENTITYNAME.Slot);
        } else {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
    }

    const handleAddProgramScheduleSlot = () => {
        setSelectedProgramScheduleSlotItem({
            _id: undefined,
            SID: 0,
            Channel: {},
            Slot: { _id: dataItem?._id, SID: dataItem?.SID },
            SlotDateTime: moment.utc().format('YYYY-MM-DDT00:00'),
            Remarks: "",
            Archive: false,
        });
        setShowProgramScheduleSlotForm(true);
    };

    const handleEditProgramScheduleSlot = (item) => {
        setSelectedProgramScheduleSlotItem(item);
        setShowProgramScheduleSlotForm(true);
    };

    const handleProgramScheduleSlotClose = (saved) => {
        setShowProgramScheduleSlotForm(false);
        setSelectedProgramScheduleSlotItem(null);
        if (saved) {loadProgramScheduleSlots();}
    };
    const EditCommandCell = (cellProps) => (
        <td style={{ textAlign: 'center' }}>
            <button className="btn btn-default btn-circle btn-my" title={lang.edit_button_tooltip ?? "Edit"} style={{ margin: '0 2px' }} onClick={() => handleEditProgramScheduleSlot(cellProps.dataItem)}>
                <i className="fa fa-pencil fa-fw" />
            </button>
        </td>
    );

    return (
        <>
            <BossDialog
                title={props.item.Title ?? lang.slot_dialog_header}
                onClose={props.cancelEdit}
                width={"800px"}
            >
                <EditPageHeader title={""} onSubmit={handleSubmit} onCancel={props.cancelEdit} showTitle={false} />
                <div className='row mt-2'>
                    <div className='col-12'>
                        <div className='row mt-2'>
                            <div className='col-4'>
                                <label>{lang.title_label} *</label>
                                <input name="Title" type="text" className="form-control form-control-sm" onChange={onChange} value={dataItem.Title} />
                            </div>
                            <div className='col-4'>
                                <label>{lang.custom_title}</label>
                                <input name="CustomTitle" type="text" className="form-control form-control-sm" onChange={onChange} value={dataItem.CustomTitle} />
                            </div>
                            <div className='col-4'>
                                <label>{lang.code_label}</label>
                                <input name="Code" type="text" className="form-control form-control-sm" onChange={onChange} value={dataItem.Code} />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-4'>
                                <label>{lang.description_label} *</label>
                                <input name="Description" type="text" className="form-control form-control-sm" onChange={onChange} value={dataItem.Description} />
                            </div>
                            <div className='col-4'>
                                <label>{lang.custom_description_label}</label>
                                <input name="CustomDescription" type="text" className="form-control form-control-sm" onChange={onChange} value={dataItem.CustomDescription} />
                            </div>
                            <div className='col-4'>
                                <label>{lang.duration_label}</label>
                                <TimePickerWithFormat className="form-control form-control-sm" name="Duration" value={dataItem.Duration} onChange={onChange}/>
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="col-4">
                                <label>{lang.genre_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={genres}
                                    name="Genre"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.Genre}
                                    onChange={onChange}
                                />
                            </div>
                            <div className='col-4'>
                                <label>{lang.production_year_label}</label>
                                <input name="ProductionYear" type="text" className="form-control form-control-sm" onChange={onChange} value={dataItem.ProductionYear} />
                            </div>
                            <div className="col-4">
                                <label>{lang.pg_rating_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={pGRatings}
                                    name="PGRating"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.PGRating}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className="col-4">
                                <label>{lang.target_audience_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={targetAudiences}
                                    name="TargetAudience"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.TargetAudience}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-4">
                                <label>{lang.production_type_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={productionTypes}
                                    name="ProductionType"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.ProductionType}
                                    onChange={onChange}
                                />
                            </div>
                            <div className="col-4">
                                <label>{lang.slot_type_label}</label>
                                <DropDownList
                                    style={{ backgroundColor: "white" }}
                                    data={slotTypes}
                                    name="SlotType"
                                    textField="Description"
                                    dataItemKey="_id"
                                    value={dataItem.SlotType}
                                    onChange={onChange}
                                />
                            </div>
                        </div>
                        <div className='row mt-2'>
                            <div className='col-3'>
                                <label>{lang.background_color_label}</label>
                                <input type="color" name="BgColor" style={{ width: "85px" }} onChange={onChange} value={dataItem.BgColor} className="form-control form-control-sm" />
                            </div>
                            <div className='col-3'>
                                <label>{lang.foreground_Color_label}</label>
                                <input type="color" name="FgColor" style={{ width: "85px" }} onChange={onChange} value={dataItem.FgColor} className="form-control form-control-sm" />
                            </div>
                            <div className='col-3'>
                                <label>{lang.breaks_label}</label>
                                <input type="number" className="form-control form-control-sm" name="Breaks" value={dataItem.Breaks} onChange={onChange} />
                            </div>
                            <div className='col-3 mt-3'>
                                <input style={{ border: "1px solid grey", marginTop: "10px" }} name={"Archive"} type='checkbox' onChange={onChange} checked={dataItem.Archive} />
                                <label className="ml-2">{lang.archive}</label>
                            </div>
                        </div>
                        {props?.item?._id && (
                            <div className='row mt-3'>
                                <div className='col-12'>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '4px' }}>
                                        <AddRoundButton title={lang.add_button_tooltip} onClick={handleAddProgramScheduleSlot}/>
                                         <label style={{ marginBottom: 0, fontWeight: 600 }}>{lang.program_schedule_slot_label}</label>
                                    </div>
                                    <Grid data={gridData} style={{ maxHeight: '400px' , height: '25vh'}} resizable={true}>
                                        <GridColumn width="50px" cell={EditCommandCell} resizable={false}/>
                                        <GridColumn field="Channel.FullChannelName" title={lang.channel_column} width="160px"/>
                                        <GridColumn field="Slot.Title" title={lang.title_column} width="160px"/>
                                        <GridColumn field="SlotDateTime" title={lang.slot_date_time_column} cell={DateTimeCell} width="200px"/>
                                        <GridColumn field="Remarks" title={lang.remark_column}/>
                                    </Grid>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </BossDialog >
            {showProgramScheduleSlotForm && selectedProgramScheduleSlotItem && (
                <ProgramScheduleSlotEditForm
                    item={selectedProgramScheduleSlotItem}
                    cancelEdit={handleProgramScheduleSlotClose}
                    onClose={handleProgramScheduleSlotClose}
                    refresh={loadProgramScheduleSlots}
                />
            )}
        </>
    )
}

export default SlotEditForm
